import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  AgrChipsFilterModule,
  AgrDaterangePickerModule,
  AgrFilterModule,
  AgrNotificationEmptyModule,
} from '@next/core-lib/components';
import { AgrTableModule } from '@next/core-lib/table';

import { PageTableFilterComponent } from './page-table-filter.component';

import { SharedModule } from '../../shared.module';

@NgModule({
  declarations: [PageTableFilterComponent],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    MatSlideToggleModule,
    MatToolbarModule,
    MatFormFieldModule,
    AgrChipsFilterModule,
    AgrDaterangePickerModule,
    AgrNotificationEmptyModule,
    AgrTableModule,
    AgrFilterModule,
    SharedModule,
  ],
  exports: [PageTableFilterComponent],
  providers: [DatePipe],
})
export class PageTableFilterModule {}
